import styled, { css } from 'styled-components';
import { rem } from '~/src/helpers/rem-converter.helper';
import {
    MAX_1279,
    MAX_1439,
    MAX_1679,
    MAX_1919,
    MAX_767,
    MIN_1440,
    MIN_1680,
    MIN_1920,
} from '~/src/styles/tokens/break-points';
import { mediaQuery } from '~/src/styles/mixins';
import { FONTS } from '~/src/styles/style-helpers/font-helper';

const CommonMediaStyles = css`
    ${mediaQuery(
        { maxWidth: MAX_1919 },
        css`
            max-width: ${rem(1046)};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_1279 },
        css`
            max-width: 100%;
        `,
    )};
`;

export const ContainerLayout = styled.main`
    width: 100%;

    ${mediaQuery(
        { minWidth: MIN_1440 },
        css`
            margin: 0 auto;
            width: ${rem(1048)};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_1439 },
        css`
            padding: 0 ${rem(124)};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_1279 },
        css`
            padding: 0;
        `,
    )};
`;

export const SectionContainerAbout = styled.section<{ isShowDocumentsBlock: boolean; }>`
    margin-bottom: ${(p) => (p.isShowDocumentsBlock ? rem(24) : rem(60))};
`;

export const SectionContainerDocumentsBlock = styled.section`
    display: flex;
    margin-bottom: ${rem(60)};

    ${mediaQuery(
        { maxWidth: MAX_1279 },
        css`
            padding: 0 ${rem(40)};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_767 },
        css`
            padding: 0 ${rem(20)};
            margin-bottom: ${rem(40)};
        `,
    )};
`;

export const SectionContainerCMSContent = styled.section<{ isNotShowRecommendProductBanner: boolean; }>`
    margin-bottom: ${(p) => (p.isNotShowRecommendProductBanner ? rem(40) : rem(60))};

    ${mediaQuery(
        { maxWidth: MAX_1279 },
        css`
            padding: 0 ${rem(40)};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_767 },
        css`
            padding: 0 ${rem(20)};
        `,
    )};
`;

export const SectionContainerRecommendProductBanner = styled.section`
    margin-bottom: ${rem(60)};

    ${mediaQuery(
        { maxWidth: MAX_1279 },
        css`
            padding: 0 ${rem(40)};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_767 },
        css`
            padding: 0 ${rem(20)};
        `,
    )};
`;

export const SectionContainerOtherDirectionProducts = styled.section`
    margin-bottom: ${rem(40)};

    ${mediaQuery(
        { maxWidth: MAX_1279 },
        css`
            padding: 0 ${rem(40)};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_767 },
        css`
            padding: 0 ${rem(20)};
        `,
    )};
`;

export const DescriptionProductTitle = styled.h2`
    ${FONTS.wide.medium.size36};
    line-height: ${rem(40)};
    margin-bottom: ${rem(32)};
`;

export const ContentContainerAboutProductBanner = styled.div``;

export const ContentContainerCMSContent = styled.div`
    max-width: ${rem(1048)};
    height: fit-content;
    flex-wrap: nowrap;
    overflow: hidden;
    ${CommonMediaStyles};

    * {
        all: revert;
    }
`;

export const SectionContainerNavigation = styled.section`
    display: flex;
    justify-content: center;
    align-items: center;

    ${mediaQuery(
        { minWidth: MIN_1680 },
        css`
            margin-bottom: ${rem(72)};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_1679 },
        css`
            margin-bottom: ${rem(80)};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_767 },
        css`
            margin-bottom: ${rem(60)};
        `,
    )};
`;

export const SectionContainerGoBack = styled.section`
    margin: ${rem(20)} 0 ${rem(12)};
    width: 100%;

    ${mediaQuery(
        { maxWidth: MAX_1279 },
        css`
            position: absolute;
        `,
    )};
`;

export const LinkWrapper = styled.div`
    display: flex;
    align-items: end;
    cursor: pointer;
`;

export const LinkWrapperGoBack = styled.div`
    width: 100%;
    max-width: ${rem(1920)};
    display: flex;
    margin: 0 auto;
    cursor: pointer;
    justify-content: flex-start;

    ${mediaQuery(
        { minWidth: MIN_1920 },
        css`
            padding: 0 ${rem(184)};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_1919 },
        css`
            padding: 0 ${rem(160)};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_1679 },
        css`
            padding: 0 ${rem(88)};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_1439 },
        css`
            padding: 0 ${rem(56)};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_1279 },
        css`
            padding: 0 ${rem(40)};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_767 },
        css`
            padding: 0 ${rem(20)};
        `,
    )};
`;

export const SvgWrapper = styled.div`
    width: ${rem(24)};
    height: ${rem(24)};
    display: flex;
    align-items: center;
    justify-content: center;
`;
